export function cpicker(ctx) {
    return {
        styles: {
            main: { bg_color: ctx.COLOR_SCR, bg_opa: 255, scale_width: 15, pad_inner: 10, radius: 999 },
            // indicator = cpicker_indic
            indicator: { border_width: 0, border_color: '#808080' },
        },
    };
}
